import React from "react";

// Shared heading for settings screens (and any screen using the sub-page tier).
//
// Placement rules (client):
//   • Title uses the title-subpage token — Leaderboard font/weight, #004d4d.
//   • Left-aligned. On desktop the title/subtitle sit OUTSIDE the content card,
//     aligned to the card's left edge (drop this inside the card's max-width
//     container, above the card, so the edges line up).
//   • Optional left-aligned subtitle in secondary grey.
// House rule: no trailing punctuation in titles; punctuation is fine in bodies.
export default function SettingsPageHeading({ title, subtitle, className = "" }) {
  return (
    <div className={`text-left ${className}`}>
      <h1 className="text-title-subpage font-bold text-[#004d4d]">{title}</h1>
      {subtitle && (
        <p className="mt-1 text-sm text-secondary">{subtitle}</p>
      )}
    </div>
  );
}
